import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { GridFilterOperator } from "@mui/x-data-grid-pro";

import moment from "moment";
import createFilter from "./helpers/CreateFilterHelper";

const CustomFilterOperatorInputDate = (props: any) => {
  const { item, applyValue } = props;
  const handleChange = (event: any) => {
    if (!moment.utc(event).isValid()) {
      event?.preventDefault();
      event?.stopPropagation();     
    }
    else
    {
      applyValue({ ...item, value: event.format('DD MMM YYYY') });
    }
  };
  
  const disableDateTyping = (e: any) => {
    if (e?.preventDefault && e?.code !== 'Tab' && e?.code !== 'Enter') { 
      e?.preventDefault();
      e?.stopPropagation();
    }
  };    

  return (
      <LocalizationProvider dateAdapter={AdapterMoment} localeText={{ fieldMonthPlaceholder: (params) => 'MMM'} }>
          <DatePicker 
              timezone="UTC"  
              format='DD MMM YYYY' 
              sx={{
                  borderWidth: '0px', 
                  outlineWidth: '0px'
              }} 
              value={moment.utc(item.value ?? null)}
              onChange={handleChange}                    
              slotProps={{
                  textField: {
                      error: false,
                      onBeforeInput: disableDateTyping, 
                      onKeyDown: disableDateTyping,                                                
                      size: 'small',
                      inputProps: { "aria-label": "Date Filter Input" }
                  }
              }}

          />
      </LocalizationProvider>
  );
};

const DateFilterOperator: GridFilterOperator[] = [
  {
      label: 'Is',
      value: 'eq',
      getApplyFilterFn: createFilter((cellValue, filterValue) => {
          if (!cellValue || !filterValue) return false;
          return moment.utc(cellValue).startOf('day').isSame(moment.utc(filterValue).startOf('day'));
      }),
      InputComponentProps: { type: 'date' },
      InputComponent: CustomFilterOperatorInputDate,
  },
  {
      label: 'Less Than',
      value: 'lt',      
      getApplyFilterFn: createFilter((cellValue, filterValue) => {
          if (!cellValue || !filterValue) return false;
          return moment.utc(cellValue).startOf('day').isBefore(moment.utc(filterValue).startOf('day'));
      }),
      InputComponentProps: { type: 'date' },
      InputComponent: CustomFilterOperatorInputDate,
  },
  {
      label: 'Greater Than',
      value: 'gt',      
      getApplyFilterFn: createFilter((cellValue, filterValue) => {
          if (!cellValue || !filterValue) return false;
          return moment.utc(cellValue).startOf('day').isAfter(moment.utc(filterValue).startOf('day'));
      }),
      InputComponentProps: { type: 'date' },
      InputComponent: CustomFilterOperatorInputDate,
  }
];

export default DateFilterOperator;